import { useSearchParams } from 'react-router-dom';
import { POSITION_DETAILS_TABS } from '../consts';
import { PARAMS_KEYS } from '../pages/PositionDetailsPage/paramKeys';

type usePositionDetailsPageQueryResponse = {
      onSearchParams: (queryParams:{[key: string]: string }) => void,
  searchParams: URLSearchParams,
  currentPage: number,
}

export const usePositionDetailsPageQuery = (): usePositionDetailsPageQueryResponse => {
  const defaultParams = {
    [PARAMS_KEYS.TAB]: POSITION_DETAILS_TABS.APP,
    [PARAMS_KEYS.PAGE]: '1',
    [PARAMS_KEYS.SHOW_HISTORY]: 'false',
  };

  const [searchParams, setSearchParams] = useSearchParams(defaultParams);
  const currentPage = parseInt(searchParams.get(PARAMS_KEYS.PAGE) || '1');
  const handleSearchParams = (queryParams: { [key: string]: string}) => {
    setSearchParams({
      ...defaultParams,
      ...queryParams,
      tab: queryParams.tab || searchParams.get(PARAMS_KEYS.TAB) || POSITION_DETAILS_TABS.APP,
      page: queryParams.page || searchParams.get(PARAMS_KEYS.PAGE) || '1',
      showHistory: queryParams.showHistory || searchParams.get(PARAMS_KEYS.SHOW_HISTORY) || 'false',
      status: queryParams.status || searchParams.getAll(PARAMS_KEYS.STATUS) || [],
    });
  };

  return {
    onSearchParams: handleSearchParams,
    searchParams,
    currentPage,
  };
};
